import { createFileRoute } from '@tanstack/react-router'
import { WorkspaceRouteShell } from '@/components/app/route-shells'
import { CalendarIntegrationWorkspace } from '@/components/calendar/calendar-integration-workspace'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'

export const Route = createFileRoute('/_app/integrations')({
  component: IntegrationsPage,
  staticData: {
    breadcrumbs: [{ label: 'Integrations', href: '/integrations' }],
  } satisfies RouteStaticData,
})

function IntegrationsPage() {
  return (
    <WorkspaceRouteShell>
      <CalendarIntegrationWorkspace />
    </WorkspaceRouteShell>
  )
}
